module.exports = __webpack_public_path__ + "static/img/zhongzhongka18.2eb6a8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhongzhongka18.png
// module id = z1oK
// module chunks = 16